module.exports = __webpack_public_path__ + "img/id.3ab7f80d.svg";